@if (visible) {
  <div class="chan-filter" role="group" aria-label="Canal">
    <small class="text-muted chan-filter-label">Canal</small>
    <button
      type="button"
      class="btn btn-sm rounded-pill"
      [class.btn-primary]="value === null"
      [class.btn-label-secondary]="value !== null"
      [attr.aria-pressed]="value === null"
      (click)="select(null)"
    >
      Todos os canais
    </button>
    @for (c of channels; track c.integrationId) {
      <button
        type="button"
        class="btn btn-sm rounded-pill"
        [class.btn-primary]="value === c.integrationId"
        [class.btn-label-secondary]="value !== c.integrationId"
        [attr.aria-pressed]="value === c.integrationId"
        (click)="select(c.integrationId)"
      >
        {{ c.name }}
      </button>
    }
  </div>
}
